<template>
  <div class="select-base-layer" :class="[menu ? 'opened-menu-bottom' : '']">
    <mf-tabs-button v-model="localBaseMapType" size="sm" :buttons="toggleButtons" @change="$emit('change')" />
  </div>
</template>

<script>
export default {
  props: {
    menu: Boolean,
    baseMapType: String,
  },
  computed: {
    localBaseMapType: {
      get() {
        return this.baseMapType
      },
      set(value) {
        this.$emit('update:baseMapType', value)
      },
    },
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Mapa',
          value: 'normal',
          active: true,
        },
        {
          id: 1,
          label: 'Satélite',
          value: 'satelite',
          active: true,
        },
      ]
    },
  },
}
</script>
